module.exports = {
  path: ':id',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/Book'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/book/routes/book/index.js